<script>
	import Data from '../../States/Data';
	import Helper from '../../Models/Helper';
	import Slider from '../../States/Slider';

	export let index;

	let element = {};
	let properties = {};
	let active = false;

	function toPericope(name) {
		const base = jQuery(element);
		const selector = `h2[data-anchor="${name}"]`;
		const target = base.find(selector);
		if (target.length) {
			const head = 25;
			const top = target.offset().top - base.offset().top + base.scrollTop() - head;
			base.animate({scrollTop: top}, 1000 * .5);
		}
	}

	function updateSlider(slides) {
		active = Slider.check(index, 'info', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			Helper.title('Info & Contact');
		}
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	p.plain {
		font-size: 1.25em;
		line-height: 1.5em;
		color: var(--secondary-color);
	}

	h2 {
		color: var(--primary-color) !important;
		margin-top: 2em;
		margin-bottom: 1em;
	}

	div.constraint {
		max-width: 45em;
	}

	p a {
		font-weight: bold;
		color: var(--secondary-color);
	}

	a.button {
		text-align: left;
	}

	/* Pericopes */

	div.pericopes.list {
		color: var(--secondary-color);
	}

	div.pericopes.list > .item {
		border-bottom: 2px solid var(--tertiary-background-light);
	}

	div.pericopes.list > .item > div {
		line-height: 1.5em;
	}

	div.pericopes.list div.name {
		margin-right: 1em;
	}

	div.pericopes.list div.name i {
		margin-right: 1em;
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Info &amp; Contact</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content" bind:this="{element}">
		<div class="constraint">
			{#if !$Data.version.beta}
				<div class="list pericopes">
					<div class="item" on:click="{event => toPericope('about')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Over de VensterBijbel
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('organization')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Over Stichting VensterBijbel
						</div>
					</div>
					{#if !Helper.app()}
						<div class="item" on:click="{event => toPericope('support')}">
							<i class="fad fa-arrow-down"></i>
							<div class="name">
								<i class="fad fa-align-left"></i> Giften
							</div>
						</div>
					{/if}
					<div class="item" on:click="{event => toPericope('contact')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Contact
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('copyright')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Copyright
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('delete')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Account verwijderen
						</div>
					</div>
					<div class="item" on:click="{event => toPericope('privacy')}">
						<i class="fad fa-arrow-down"></i>
						<div class="name">
							<i class="fad fa-align-left"></i> Privacy beleid
						</div>
					</div>
				</div>
				<h2 data-anchor="about">Over de VensterBijbel</h2>
				<p>De VensterBijbel is gebaseerd op de Statenvertaling, het is dus geen vertaling uit de grondtalen. Doel is een Bijbel met een woordkeus op een gemiddeld leesniveau, die wel dicht bij de tekst van de Statenvertaling blijft, maar prettiger leest, begrijpelijker is en geschikt is voor bijbelstudie. De tekst volgt de traditionele vers- en hoofdstukindeling van de Statenvertaling, waardoor hij bij uitstek geschikt is voor vergelijking met Bijbels in andere talen.</p>
				<p>De naam VensterBijbel is geïnspireerd door Psalm 36:10 – ‘In uw licht zien wij het licht.’ Zoals een venster ons van licht voorziet en een uitzicht geeft, biedt de Bijbel ons zicht op God en zijn plan met de mens, en geeft ons licht op ons levenspad en een blik op de toekomst.</p>
				<p>De VensterBijbel is ondergebracht in Stichting VensterBijbel en is sinds 2023 digitaal beschikbaar als website en als app in Google Play.</p>

				<h2 data-anchor="organization">Over Stichting VensterBijbel</h2>
				<p>De VensterBijbel wordt beheerd door Stichting VensterBijbel. Deze Stichting is gekoppeld aan Stichting BasisBijbel.</p>
				<p>Beide Stichtingen gaan uit van de betrouwbaarheid van de Bijbel en willen in hun Bijbels recht doen aan het profetisch karakter dat vele teksten hebben en aan de onderlinge samenhang van de verschillende Bijbelboeken.</p>
				<a class="button" on:click="{event => toPericope('detail')}">
					<i class="fad fa-info-circle"></i> Meer over stichting VensterBijbel
				</a>

				{#if !Helper.app()}
					<h2 data-anchor="support">Giften</h2>
					<p>Waardeer je de VensterBijbel? Je kunt het werk van Stichting VensterBijbel steunen met een gift op bankrekening <strong>NL89 SNSB 0871 2859 24 t.n.v. Stichting BasisBijbel</strong> onder vermelding van “VensterBijbel”.</p>
					<p>(Stichting VensterBijbel is gekoppeld aan Stichting BasisBijbel. Om de kosten zo laag mogelijk te houden, hebben de beide Stichtingen samen één bankrekening, op naam van Stichting BasisBijbel.)</p>
					<p><strong>NB:</strong> Stichting VensterBijbel is <em>geen</em> ANBI. Voor de Stichting betekent dit, dat giften tot € 2000,- belastingvrij zijn, maar dat de Stichting over hogere bedragen belasting moet betalen. Voor de gever betekent het dat hij zijn gift(en) aan de Stichting niet als “goed doel” kan aftrekken voor de belasting.</p>
				{/if}

				<h2 data-anchor="contact">Contact</h2>
				<p>Heb je vragen? Opmerkingen? Foutje gevonden? Stuur ons dan een e-mail via de onderstaande knop.</p>
				<a class="button" href="mailto:info@vensterbijbel.nl" target="_blank">
					<i class="fad fa-envelope"></i> info@vensterbijbel.nl
				</a>

				<h2 data-anchor="copyright">Copyright</h2>
				<p>Het copyright berust bij Stichting VensterBijbel. Tekst uit de VensterBijbel mag niet op enige wijze gekopieerd, verspreid en doorgegeven worden, in gedrukte vorm, digitaal of anderszins, behalve onder onze voorwaarden.</p>
				<a class="button"  on:click="{event => toPericope('conditions')}">
					<i class="fad fa-balance-scale"></i> Klik hier voor de voorwaarden
				</a>

				<h2 data-anchor="delete">Account verwijderen</h2>
				<p>Wil je je account verwijderen? Zorg eerst dat je ingelogd staat. Klik daarna in het menu op je naam en volg de aanwijzingen. Al je gegevens en aantekeningen worden dan definitief gewist.</p>

				<h2 data-anchor="privacy">Privacy beleid</h2>
				<p>Wij gaan zorgvuldig om met je persoonlijke gegevens, om je privacy te beschermen. Op de onderstaande pagina vertellen we welke gegevens we verzamelen als je onze website gebruikt, waarom we deze gegevens verzamelen en wat we ermee doen.</p>
				<a class="button" href="/privacy">
					<i class="fad fa-file-contract"></i> Privacy beleid
				</a>

				<h2 data-anchor="detail">Doelstelling</h2>
				<p>Stichting VensterBijbel heeft als doel de Bijbel voor zoveel mogelijk mensen toegankelijk te maken. Dit doet zij in samenwerking met Stichting BasisBijbel. De Stichting wil dit bereiken op de volgende manieren:</p>
				<ul>
					<li>1. Het aanbieden van een gratis te lezen Bijbel op het internet, op een gemiddeld leesniveau en geschikt voor bijbelstudie: www.vensterbijbel.nl</li>
					<li>2. De VensterBijbel ter beschikking te stellen voor ‘doelgroepbijbels’</li>
					<li>3. De VensterBijbel aan te bieden als gratis online-app in Google Play</li>
				</ul>

				<h2>Gegevens</h2>
				<p>
					Opgericht 2 maart 2023 te Leiderdorp<br/>
					KvK. nr. 89438701<br/>
					Bankgegevens: Stichting VensterBijbel heeft een gemeenschappelijke rekening met Stichting BasisBijbel. Banknummer: <strong>NL89 SNSB0871 2859 24 t.n.v. Stichting BasisBijbel</strong>
				</p>
				<p>Stichting VensterBijbel is <em>geen</em> ANBI. Voor de Stichting betekent dit, dat giften tot € 2000,- belastingvrij zijn, maar dat de stichting over hogere bedragen belasting moet betalen. Voor de gever betekent het dat hij zijn gift(en) aan de stichting niet als “goed doel” kan aftrekken voor de belasting.</p>

				<h2 data-anchor="conditions">Voorwaarden voor het gebruik van tekst uit de VensterBijbel.</h2>
				<p>Het copyright berust bij Stichting VensterBijbel. Alle rechten voorbehouden.</p>
				<p>De inhoud van de VensterBijbel mag NIET op enige wijze gekopieerd, verspreid en doorgegeven worden, in gedrukte vorm, digitaal of anderszins, behalve onder de volgende voorwaarden:</p>
				<p>1. Bij <strong>DIGITAAL</strong> gebruik mogen er maximaal 50 verzen <em>per Bijbelboek</em> gebruikt worden zonder toestemming, op voorwaarde dat het gebruik van de digitale tekst gratis is. Voor commercieel gebruik of gebruik van meer Bijbelverzen moet toestemming worden gevraagd bij de eigenaar van de VensterBijbel: Stichting VensterBijbel.</p>
				<p>2. Bij gebruik <strong>IN DRUK</strong> mogen er in totaal uit de <em>gehele Bijbel</em> maximaal 50 verzen gebruikt worden zonder toestemming. Voor gebruik van meer Bijbelverzen moet toestemming gevraagd worden bij stichting VensterBijbel.</p>
				<p>3. Voor het inlezen van tekst in <strong>AUDIO- of VIDEO-</strong>bestanden, moet ALTIJD toestemming gevraagd worden aan Stichting VensterBijbel.</p>
				<p>4. Voor <strong>COMMERCIEEL GEBRUIK</strong> moet toestemming gevraagd worden aan Stichting VensterBijbel. Onder commercieel gebruik verstaan wij elke vorm van verkoop, digitaal of fysiek, via websites, winkels of internetwinkels, en gebruik als geschenk bij producten, contributies, donaties, e.d.</p>
				<p>5. Bij <strong>IEDER GEBRUIK VAN TEKST</strong>: uitsluitend onder vermelding van de volledige naam VensterBijbel. Waar dit echt niet kan en VensterBijbel wordt afgekort, moet de afkorting VB gebruikt worden. Bij gebruik van tekst op foto&#39;s moet de naam VensterBijbel duidelijk leesbaar op de foto vermeld worden.</p>
				<p>6. Bij gebruik van beeldmateriaal: uitsluitend onder vermelding van de daarbij genoemde bron.</p>
				<p>7. Tekst en/of beeldmateriaal mag niet bewerkt/gewijzigd worden.</p>
				<p>8. Voor elementen in de website die zich in het publiek domein bevinden, geldt de daarbij behorende wetgeving. Deze licentie brengt daar geen verandering in.</p>
				<p>9. Deze licentie brengt geen verandering in intellectuele eigendomsrechten van derden.</p>

			{:else}
				<p>Deze website is nog in ontwikkeling en ook aan de tekst van de bijbelvertaling wordt nog volop gewerkt.</p>
			{/if}
		</div>
	</div>
</div>